/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */
import styled from 'styled-components';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import MenusNav from '@base/MenusNav/MenusNav';
import ContentsTable from '@base/ContentsTable/ContentsTable';
import { menus } from '@utils/constants';
import { Fonts, TextColors, Spacings } from '@styles/index';

const Left = styled.div`
  grid-column: 1/6;
  position: fixed;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Right = styled.div`
  grid-column: 6/25;
  @media (max-width: 768px) {
    grid-column: 1/25;
    margin-left: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const SubscriptionTermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const SubscriptionTermsContainer = styled.div`
  li {
    font-weight: ${Fonts.REGULAR};
    font-size: ${Fonts.P1};
    line-height: ${Fonts.HEADER_LINE_HEIGHT};
    color: ${TextColors.BLACK};
  }
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
  padding-top: 100px;
  margin-top: -100px;
`;

const H2Container = styled.div``;

const tableData = [
  { label: 'A. Subscription & Eligibility', id: 'eligibility' },
  { label: 'B. Compatible devices', id: 'compatible_devices' },
  { label: 'C. Educational content', id: 'educational_content' },
  { label: 'D. Additional terms', id: 'additional_terms' }
];

const SubscriptionTerms = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <Left>
        <MenusNav data={menus} currentHref={pathname} />
      </Left>

      <Right>
        <SubscriptionTermsWrapper>
          <SubscriptionTermsContainer>
            <H2Container>
              <H2>Unacademy Plus - Subscription Terms & Conditions</H2>
            </H2Container>
            <br />
            <br />
            <ContentsTable data={tableData} />

            <div>
              <P1>
                Welcome to the terms of use for Unacademy Plus - Subscription.
                These terms are between you and Sorting Hat Technologies Private
                Limited (“Unacademy”, “we” or “us”). Please read these terms,
                along with the Privacy Policy, Terms of Use, and all other rules
                and policies made available or published on Unacademy platform
                or mobile application (including, but not limited to, any rules
                or usage provisions specified on any page or on any help or
                other informational page on Unacademy website or mobile
                application) (collectively, this "Agreement"). The versions of
                the above-mentioned policies and terms are available on
                Unacademy website and/or mobile application for your reference
                and to understand how we handle your personal information. Every
                time you visit, browse, or use your Unacademy Subscription, you
                accept this Agreement.
              </P1>
              <br />
              <br />
              <a name="eligibility">
                <StyledH3>A. Subscription &amp; Eligibility</StyledH3>
              </a>
              <P1>
                Unacademy Plus Subscription (the "Subscription Service") is a
                personalized Subscription that offers, recommends and helps you
                discover digital educational content created and live streamed
                by top educators (collectively, "Educational Content") in the
                category of your interest. You can access the Subscription and
                Educational Content, through the Unacademy website or Unacademy
                mobile application by subscribing to any category of your choice
                from the available subscription plans (“Subscription”). The
                Subscription will allow you access to all the courses/classes
                that are on-going during your Subscription Period. If you are
                under 18 years of age, or the age of majority in your location,
                you may use the Subscription only with involvement of a parent
                or guardian. We personalize content and features them as part of
                the Subscriptions, including showing you recommendations on
                Educational Content in the subscribed category, features and
                other related categories that might be of interest to you. We
                also endeavor to continuously improve the Subscriptions and
                subscription plans to improve your subscription experience.
              </P1>
              <br />
              <br />
              <a name="compatible_devices">
                <StyledH3>B. Compatible devices</StyledH3>
              </a>
              <P1>
                In order to access the live-streamed courses/classes or to
                download the Educational Content in the mobile application, you
                will need to use a personal computer, portable media player, or
                other device that meets the system and compatibility
                requirements (a "Compatible Device"). The Compatible Devices may
                change from time to time and, in some cases, whether a device is
                (or remains) a Compatible Device may depend on software or
                systems provided or maintained by the device manufacturer or
                other third parties. Accordingly, devices that are Compatible
                Devices at one time may cease to be Compatible Devices in the
                future. Thus, kindly make sure that the device that you use is
                compatible with our system/software to avail the Subscription
                Service.
              </P1>
              <br />
              <br />
              <a name="educational_content">
                <StyledH3>C. Educational content</StyledH3>
              </a>
              <ol>
                <li>
                  The Subscription allows you to access live-streaming of
                  Educational Content on a subscription basis in the subscripted
                  category for viewing, for a limited period of time during the
                  Subscription Period.
                </li>
                <br />
                <li>
                  <strong>Usage Rules: </strong>
                  <br />
                  <br />
                  Due to the limitations imposed on us by our Educational
                  Content providers i.e. Educators, the Educational Content we
                  make available to you on Unacademy Plus Subscription are
                  subject to restrictions on viewing access and on the length of
                  time we make them available to you. These restrictions may
                  change over time as we add new features, devices and content
                  to our Subscription Service. The following are restrictions
                  for accessing Educational Content on Unacademy Plus
                  Subscription:
                </li>
                <br />
                <ol>
                  <li>
                    <strong>Live – Streaming of Education Content:</strong>
                    <br />
                    You shall get access to attend live- streamed
                    classes/courses of the Educational Content in your
                    subscribed category during the Subscription Period through
                    your Web browser/mobile application through compatible
                    Internet-connected devices.
                  </li>
                  <li>
                    <strong>Downloading</strong>
                    <br />: You shall only have option to do in-app download and
                    the downloaded Educational Content can be viewed by you
                    during the Subscription Period in your compatible devices.
                    After downloading the Educational Content, you shall have
                    access to the same for the Subscription Period only and all
                    access to the downloaded content shall be removed on expiry
                    or termination of your Subscription, as the case maybe.
                  </li>
                  <li>
                    <strong>Viewing Period:</strong>
                    <br />
                    You can attend the live-streamed courses/classes of the
                    Educational Content and watch and re-watch them later during
                    your Subscription Period, by in-app downloading or streaming
                    it, as often as you want and as long as you want provided
                    that you have an active subscription and the viewing is
                    within the Subscription Period or for a period of time as
                    provided in this Agreement.
                  </li>
                </ol>
                <br />
                <li>
                  <strong>Subscription &amp; Payment.</strong>
                  <br />
                  You can subscribe to the category of your choice by clicking
                  the Subscribe option and making the required payment for the
                  subscription plan of your choice.
                </li>
                <br />
                <li>
                  <strong>Limited License to Educational Content.</strong>
                  <br />
                  Subject to payment of the Subscription fee, and your
                  compliance with all terms of this Agreement, Unacademy and the
                  Educator grants you a non-exclusive, non-transferable,
                  non-sublicensable, limited license, during the applicable
                  Subscription Period, to access and view and attend
                  live-streamed classes/courses of the Educational Content in
                  accordance with the terms of this Agreement, for personal,
                  non-commercial, private use only. We may automatically remove
                  you access to the Educational Content from your Compatible
                  Device after the end of the Subscription Period or in
                  accordance with any restriction mentioned in this Agreement.
                </li>
                <br />
                <li>
                  <strong>
                    Availability of Subscribed Educational Content.
                  </strong>
                  <br />
                  Educational Content will generally continue to be available to
                  you for in app download or streaming or attending
                  live-streamed classes/courses during the Subscription Period,
                  as applicable, but may become unavailable due to potential
                  Educator licensing restrictions or for other reasons, and
                  Unacademy will not be liable to you if the Educational Content
                  in the subscribed category becomes unavailable for further in
                  app download or streaming. You may download and store your own
                  copy of Educational Content on a Compatible Device authorized
                  for such in app download so that you can view that Educational
                  Content but the access to such in-app downloaded Educational
                  Content shall be removed on expiry of the Subscription Period
                  or in case of Educator licensing restriction or termination of
                  the Subscription in accordance with the terms of this
                  Agreement.
                </li>
                <br />
                <li>
                  <strong>In-App Downloading. </strong>
                  You are granted license only for in-app download of the
                  Educational Content in the mobile application or on such
                  Compatible Device so permitted. Screen-casting or downloading
                  on any other device or in any manner not permitted herein
                  shall amount to immediate termination of Subscription along
                  with termination of access to all downloaded Educational
                  Content with a right to initiate appropriate legal action, at
                  the sole discretion of Unacademy.
                </li>
                <br />
                <li>
                  <strong>Quality of Streaming.</strong>
                  The resolution and quality of the Educational Content you
                  receive will depend on a number of factors, including the type
                  of Compatible Device on which you are accessing the
                  Educational Content and your bandwidth, which may increase or
                  decrease over the course of your viewing. While we strive to
                  provide you a high-quality viewing experience, we make no
                  guarantee as to the resolution or quality of the Educational
                  Content you will receive when streaming.
                </li>
                <br />
                <li>
                  <strong>General Restrictions.</strong>
                  You may not (i) transfer, copy or display the Educational
                  Content, except as permitted in this Agreement; (ii) sell,
                  rent, lease, distribute, or broadcast any right to the
                  Educational Content; (iii) remove any proprietary notices or
                  labels on the Educational Content; (iv) attempt to disable,
                  bypass, modify, defeat, or otherwise circumvent any digital
                  rights management or other content protection system used as
                  part of the Subscription; or (v) use the Subscription or
                  Educational Content for any commercial or illegal purpose.
                </li>
              </ol>
              <br />
              <br />

              <a name="additional_terms">
                <StyledH3>D. Additional terms</StyledH3>
              </a>
              <ol>
                <li>
                  <strong>Communications.</strong>
                  We may send you promotions or otherwise communicate with you
                  electronically, which may include e-mail, push notification,
                  and you hereby consent to receive those communications. These
                  communications will be in accordance with the Unacademy
                  Privacy Policy.
                </li>
                <br />
                <li>
                  <strong>Modification of Subscription.</strong>
                  Unacademy reserves the right to modify, suspend, or
                  discontinue the Subscription Service, or any part of the
                  Subscription Service, at any time and without notice (except
                  as required by applicable law), and Unacademy will not be
                  liable to you should it exercise such rights, even if your
                  ability to use Educational Content is impacted by the change.
                </li>
                <br />
                <li>
                  <strong>Amendments.</strong>
                  Unacademy reserves the right to make changes to this Agreement
                  at any time by posting the revised terms in connection with
                  the Subscription Service. To the maximum extent permitted by
                  law, your continued use of the Subscription Service following
                  any changes will constitute your acceptance of such changes.
                </li>
                <br />
                <li>
                  <strong>Reservation of Rights; Waiver. </strong>
                  The Subscription Service and the Educational Content embody
                  intellectual property that is protected by law. Copyright
                  owners of Educational Content, i.e. Educator, are intended
                  third-party beneficiaries under the Agreement. Our failure to
                  insist upon or enforce your strict compliance with the
                  Agreement will not constitute a waiver of any of our rights.
                </li>
                <br />
                <li>
                  <strong>Disputes/Conditions of Use. </strong>
                  Any dispute or claim arising from or relating to this
                  Agreement or the Subscription Service is subject to the
                  governing law, disclaimer of warranties and limitation of
                  liability, any binding arbitration, and all other terms in the
                  Unacademy Terms of Use. You agree to those terms by using the
                  Subscription Service.
                  <strong> </strong>
                </li>
                <br />
                <li>
                  <strong>Limitation of Liability.</strong>
                  Without limiting the disclaimer of warranties and limitation
                  of liability in the Unacademy Terms of Use: (i) in no event
                  shall our total liability to you for all damages arising out
                  of or related to your use or inability to use the Subscription
                  Service exceed the amount of INR 500 (Indian Rupees Five
                  Hundred); and (ii) in no event shall our or our Educational
                  Content providers' i.e. Educator’s total liability to you for
                  all damages arising from your use of the Subscription Service,
                  the Educational Content, or information, materials included on
                  or otherwise made available to you through the Subscription
                  Service, exceed INR 500 (Indian Rupees Five Hundred). The
                  limitations in this section will apply to you even if the
                  remedies fail of their essential purpose.
                </li>
                <br />
                <li>
                  <strong>Contact Information.</strong>
                  For communications concerning this Agreement, please write to
                  Unacademy at{' '}
                  <a href="mailto:help@unacademy.com">help@unacademy.com</a>.
                </li>
                <br />
                <li>
                  <strong>Severability.</strong>
                  If any term or condition of this Agreement is deemed invalid,
                  void, or for any reason unenforceable, that part will be
                  deemed severable and will not affect the validity and
                  enforceability of any remaining term or condition.
                </li>
                <br />
                <br />
              </ol>
            </div>
            <br />
            <br />
          </SubscriptionTermsContainer>
        </SubscriptionTermsWrapper>
      </Right>
    </>
  );
};

SubscriptionTerms.pageInfo = {
  name: 'Unacademy Subscription Terms',
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default SubscriptionTerms;
